<template>
  <PageTemplate
    :datas="datas"
    :nv-items="nvItems"
    :lang="lang"
    page-name="about-us"
    @homeClick="hClick"
  />
</template>

<script>
import PageTemplate from "@/components/PageTemplate.vue";
import { getAboutUs } from "@/api/data.js";
export default {
  components: {
    PageTemplate,
  },
  props: ["lang"],
  data() {
    return {
      datas: [],
      activeItem: 0,
      nvItems: [
        {
          name: "首页",
          path: "/",
          enName: "Home",
        },
        {
          name: "我们",
          path: "",
          enName: "About Us",
        },
      ],
    };
  },

  mounted() {
    console.log("---------------");
    this.getData();
  },
  methods: {
    menuItemClick(e) {
      this.activeItem = parseInt(e);
    },

    hClick(name) {
      console.log("about us" + name);
      this.$emit("toHome");
    },

    getData() {
      let that = this;
      getAboutUs()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.datas = data;
          } else {
            that.datas = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.datas = [];
        });
    },
  },
};
</script>

<style scoped></style>
